import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import './ChangePassword.css';

const ChangePassword = () => {
    const [searchParams] = useSearchParams();
    const [password, setPassword] = useState('');
    const [message, setMessage] = useState('');
    const navigate = useNavigate();

    const token = searchParams.get('token');

    // New function to verify token
    const verifyToken = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/verify-token?token=${token}`);
            if (!response.ok) {
                const data = await response.json();
                setMessage(data.error || 'Token verification failed.');
            } else {
                setMessage('Please enter your new password.');
            }
        } catch (error) {
            setMessage('An error occurred while verifying the token.');
        }
    };

    useEffect(() => {
        if (token) {
            verifyToken();
        } else {
            setMessage('No token provided.');
        }
    }, [token]);

    const handleChangePassword = async (event) => {
        event.preventDefault();
        try {
            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/change-password`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    token: token,
                    new_password: password
                }),
            });
            const data = await response.json();
            if (response.ok) {
                setMessage('Your password has been successfully changed.');
                setTimeout(() => navigate('/signin'), 3000);
            } else {
                setMessage(data.error || 'Failed to change password.');
            }
        } catch (error) {
            setMessage('An error occurred while changing the password.');
        }
    };

    return (
        <div className="change-password-container">
            <h1 className="change-password-title">Change Password</h1>
            {message && <div className="change-password-message">{message}</div>}
            <form className="change-password-form" onSubmit={handleChangePassword}>
                <input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="New Password"
                    required
                />
                <button type="submit" className="change-password-button">Change Password</button>
            </form>
        </div>
    );
};

export default ChangePassword;
